import { CRYPTO_ASSETS, NETWORKS } from '../../../lib/constants'
import { config } from '../../../config'
import { formatMYR } from '../../../lib/utils'
import { layout, ui, cx, text } from '../../../lib/ui-primitives'
import { BackIcon } from '../../icons'
import type { useKiosk } from '../../../hooks/useKiosk'

interface NetworkScreenProps {
  kiosk: ReturnType<typeof useKiosk>
}

export function NetworkScreen({ kiosk }: NetworkScreenProps) {
  const { selectedCrypto, selectNetwork, setScreen } = kiosk

  if (!selectedCrypto) return null

  const asset = CRYPTO_ASSETS[selectedCrypto]

  return (
    <div className={layout.screenContent}>
      <button
        onClick={() => setScreen('welcome')}
        className={ui.backBtn}
        aria-label="Go back to crypto selection"
      >
        <BackIcon aria-hidden="true" /> <span>Back</span>
      </button>

      <div className="text-center mb-6 sm:mb-8">
        <div
          className={cx(ui.pill, 'mb-4')}
          style={{ backgroundColor: `${asset.color}18` }}
        >
          <span aria-hidden="true">{asset.icon}</span>
          <span className="text-white font-medium">{selectedCrypto}</span>
        </div>
        <h2 className={text.h2}>Select Network</h2>
        <p className={cx('text-sm mt-1', text.secondary)}>
          Choose blockchain network for receiving
        </p>
      </div>

      <div className="flex-1 overflow-auto">
        <div className="space-y-3 max-w-sm mx-auto">
          {asset.networks.map((network) => (
            <button
              key={network}
              onClick={() => selectNetwork(network)}
              className={ui.selectionCard}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="text-2xl" aria-hidden="true">
                    {NETWORKS[network].icon}
                  </span>
                  <div className="text-left">
                    <div className="text-white font-medium">{network}</div>
                    <div className={cx('text-sm', text.tertiary)}>
                      {NETWORKS[network].name}
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className={cx('text-white text-sm', text.numeric)}>
                    {formatMYR(config.networkFees[network])}
                  </div>
                  <div className={cx('text-xs', text.disabled)}>network fee</div>
                </div>
              </div>
            </button>
          ))}
        </div>

        <p className={cx('text-center text-xs mt-6 max-w-sm mx-auto', text.disabled)}>
          Lower fees = longer confirmation. Choose based on your preference.
        </p>
      </div>
    </div>
  )
}
